import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UtilityService } from '@app/_services/utility.service';
import { APP_ROUTE_PREFIX } from '@app/enums';

export const guestGaurd: CanActivateFn = () => {
  const utility = inject(UtilityService);
  const router = inject(Router);

  if (utility.isUserLoggedIn()) {
     router.navigate([APP_ROUTE_PREFIX]);
    return false;
  }
  return true;
};
